/**
 * 全局的设置
 */

// 首页的模块按钮
export const IndexPageModule = [
  {
    key: 0,
    value: '血糖仪使用',
    img: '/static/images/usage.png'
  }, 
  // {
  //   key: 1,
  //   value: '注册',
  //   img: '/static/images/register.png'
  // }, 
  {
    key: 1,
    value: '积分',
    img: '/static/images/credits.png'
  }, {
    key: 2,
    value: '物流',
    img: '/static/images/logistics.png'
  }, {
    key: 3,
    value: '试纸',
    img: '/static/images/cdv.png'
  }
]

const patientId = localStorage.getItem('patientId')

// 前端的链接指令
export const JumpLink = [
  {
    text: '【血糖仪购买】👈', link: process.env.VUE_APP_LINK_4.replaceAll('{patientId}', patientId)
  }, {
    text: '【试纸购买】👈', link: process.env.VUE_APP_LINK_3.replaceAll('{patientId}', patientId)
  }, {
    text: '【福利申请】👈', link: `${process.env.VUE_APP_DXY_DOMAIN}/lccp-wechat/f2e/goods/apply?routeFrom=center&source=0`
  }, {
    text: '【实体卡】👈', link: process.env.VUE_APP_LINK_1
  }, {
    text: '【积分社区】👈', link: '/pages/authorization/authorization?type=2&jump=/pointCommunity-page/index/index?originfrom=wx-mpnews'
  }, {
    text: '【积分规则】👈', link: '/pages/authorization/authorization?type=2&jump=%2FpointCommunity-page%2Frule%2Frule%3Foriginfrom%3Dwx-chatbot'
  }, {
    text: '【积分兑换】👈', link: '/pages/authorization/authorization?type=2&jump=%2FpointCommunity-page%2Fexchange%2Fexchange%3Foriginfrom%3Dwx-chatbot'
  }, {
    text: '【点击这里】👈', link: process.env.VUE_APP_LINK_1
  }, {
    text: '【血糖仪使用-三诺】👈', link: process.env.VUE_APP_LINK_5, showTitle: '【血糖仪使用】👈'
  }, {
    text: '【血糖仪使用-糖大夫】👈', link: process.env.VUE_APP_LINK_6, showTitle: '【血糖仪使用】👈'
  }
]
